/**
 * INV-TEL-OFFLINE: an offline transport answer is an expected outcome in a local-first app, as a cancellation is
 * (INV-TEL-CANCEL). Only the fetch boundary knows a TypeError came from the network, so it marks the TypeError it
 * rethrows; a TypeError from code outside a fetch stays unmarked and remains an error. A status-0 answer is offline only
 * through its marked cause: wrappers stamp status 0 on failures that are not the network
 * (db-turso-browser-adapter replica-transport.ts:56). Accepted gap: a fetch TypeError from a CORS or CSP refusal, or
 * from code inside the fetch implementation, cannot be told apart by type and also counts as offline.
 */
const fetchNetworkFailures = new WeakSet<object>()

export function markFetchNetworkFailure(error: unknown): void {
  if (typeof error === 'object' && error !== null) fetchNetworkFailures.add(error)
}

/** The error, or one in its `cause` chain, is a TypeError the instrumented fetch rethrew. */
export function isOfflineFailure(error: unknown): boolean {
  const seen = new Set<unknown>()
  for (let current = error; typeof current === 'object' && current !== null && !seen.has(current); current = (current as { cause?: unknown }).cause) {
    seen.add(current)
    if (fetchNetworkFailures.has(current)) return true
  }
  return false
}
